(function() {
  const targetNode = document.querySelector('body');
  const config = { childList: true, subtree: true };

  const callback = (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.removedNodes[0]?.childNodes[0]?.id === 'kaktus-wishlist-widget') {
        combineProductsFromWishlist();
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  async function combineProductsFromWishlist() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      const cart = await response.json();
      const cartCounters = document.querySelectorAll('.cart-link__count');
      const section = {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selectors: ['.f-cart-drawer__items', '.f-drawer__footer', '[data-cart-count-bubble]'],
      };
      const mainCartFooterSection = {};
      const reverseItems = [...cart.items].reverse();
      let counter = reverseItems.length;

      if (cartCounters.length !== 0) {
        cartCounters.forEach((cartCounter) => {
          const cartCounterNumber = cartCounter.querySelector('[data-cart-count-number]');

          if (cartCounterNumber) {
            cartCounterNumber.textContent = `${cart.item_count}`;
          }

          if (cart.item_count > 0) {
            cartCounter.classList.remove('is-cart-empty');
          }
        })
      }

      if (document.getElementById('main-cart-items')) {
        section.id = 'main-cart-items-wrapper';
        section.section = document.getElementById('main-cart-items').dataset.id;
        section.selectors = ['.f-cart'];
        mainCartFooterSection.id = 'main-cart-footer';
        mainCartFooterSection.section = document.getElementById('main-cart-footer').dataset.id;
        mainCartFooterSection.selectors = ['.f-cart__footer'];
      }

      for (const item of reverseItems) {
        if (item.properties.offer) {
          gtag('event', 'added_product_from_wishlist', {
            'item_id': item.id,
            'item_key': item.key,
            'item_name': item.title,
            'item_brand': item.vendor,
            'item_category': item.product_type,
            'price': item.price / 100,
            'quantity': item.quantity
          });
        }

        const updatedProperties = { ...item.properties };
        delete updatedProperties.offer;

        const body = JSON.stringify({
          line: counter,
          quantity: item.quantity,
          properties: updatedProperties,
          sections: [section.section, mainCartFooterSection.section],
          sections_url: window.location.pathname,
        });

        counter--;
        const updateResponse = await fetch(`${FoxThemeSettings.routes.cart_change_url}`, { ...fetchConfig, ...{ body } });
        const updateData = await updateResponse.text();
        const parsedState = await JSON.parse(updateData);
        const wrapperElement = document.querySelector(section.section);
        const mainCartFooter = document.getElementById('main-cart-footer');

        if (parsedState.sections[section.section]) {
          const domParser = new DOMParser().parseFromString(parsedState.sections[section.section], 'text/html');
          section.selectors.forEach(selector => {
            const elementToReplace = document.getElementById(section.id).querySelector(selector) || document.getElementById(section.id);
            const newSection = domParser.querySelector(selector) ? domParser.querySelector(selector).innerHTML : '';
            elementToReplace.innerHTML = newSection;

            if (selector === '.f-cart') {
              if (document.querySelector('cart-items.f-cart')?.classList?.contains('is-empty') && !domParser.querySelector(selector)?.classList?.contains('is-empty')) {
                document.querySelector('cart-items.f-cart').classList.remove('is-empty')
              }
            }
          });

          if (wrapperElement?.classList?.contains('is-empty') && !domParser.querySelector(section.section)?.classList?.contains('is-empty')) {
            wrapperElement.classList.remove('is-empty')
          }
        }

        if (mainCartFooter) {
          const domParserFooter = new DOMParser().parseFromString(parsedState.sections[mainCartFooterSection.section], 'text/html');

          mainCartFooterSection.selectors.forEach(selector => {
            const elementToReplace = document.getElementById(mainCartFooterSection.id).querySelector(selector) || document.getElementById(mainCartFooterSection.id);
            const newSection = domParserFooter.querySelector(selector) ? domParserFooter.querySelector(selector).innerHTML : '';
            elementToReplace.innerHTML = newSection;
          });

          if (mainCartFooter?.classList?.contains('is-empty') && !domParserFooter.querySelector(section.section)?.classList?.contains('is-empty')) {
            mainCartFooter.classList.remove('is-empty')
          }
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
})();
